import { staticDropdownValuesService } from "services";

const loadOptions = async () => {
	try {
		const options = await staticDropdownValuesService.getHighRiskType();

		return {
			options,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const highRiskColumn = () => ({
	name: "isHighRisk",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.name,
	getOptionValue: option => option.id,
	placeholder: "High Risk",
});

export default highRiskColumn;
